export const IconShip = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.63 14.6601L21.22 16.5201C20.51 19.72 18 22.0001 14.38 22.0001H9.61998C5.99998 22.0001 3.48999 19.72 2.77999 16.5201L2.36998 14.6601C2.16998 13.7501 2.70997 12.7201 3.57997 12.3701L4.99999 11.8L10.51 9.59006C10.99 9.40006 11.5 9.30005 12 9.30005C12.5 9.30005 13.01 9.40006 13.49 9.59006L19 11.8L20.42 12.3701C21.29 12.7201 21.83 13.7501 21.63 14.6601Z"/>
      <path opacity="0.4" d="M19 8V11.8L13.49 9.59C12.53 9.21 11.47 9.21 10.51 9.59L5 11.8V8C5 6.35 6.35 5 8 5H16C17.65 5 19 6.35 19 8Z"/>
      <path d="M14.5 5H9.5V3C9.5 2.45 9.95 2 10.5 2H13.5C14.05 2 14.5 2.45 14.5 3V5Z"/>
    </svg>
  );
};